import { Button } from '@athena/forge';
import { getLocalizedString } from '../../utils/i18n-utils';
import { hideWidgetForm } from '../../utils/widget-facade';
import ResetAccountSection from './ResetAccountSection';
import { useWidgetContext } from '../context/WidgetContext';

export default function ResetAccountLink() {
  const { eventEmitter } = useWidgetContext();

  const onResetAccount = () => {
    hideWidgetForm();
    eventEmitter.emitEventToComponent({
      componentName: ResetAccountSection.displayName!,
      eventName: 'render-reset-account-screen',
      eventPayload: {},
    });
  };

  return (
    <Button
      id='reset-account-link'
      text={getLocalizedString('accountreset.link')}
      variant="tertiary"
      size="small"
      fullWidth={false}
      onClick={onResetAccount}
    />
  );
}
